import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { BILLING_INVOICE, PAYER_PRIMARY, formatTermDate, planDisplay, primaryLabel } from './addOnRenewalHelpers'

/** Step 5: enrolled. */
const Confirmation = ({ plan, termStart, termEnd, payer, billing, primaryName, onDone }) => {
    const end = formatTermDate(termEnd)
    const payerLine = payer === PAYER_PRIMARY
        ? `Paid by ${primaryLabel(primaryName)}`
        : billing === BILLING_INVOICE
            ? 'Invoiced monthly by email, due within 7 days'
            : 'Billed monthly to your card on file'

    const start = formatTermDate(termStart)
    const row = (label, value, testId) => <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '10px 0', borderTop: '1px solid #e3e6eb' }}>
        <Typography color="textSecondary">{label}</Typography>
        <Typography style={{ fontWeight: 600, textAlign: 'right' }} data-testid={testId}>{value}</Typography>
    </div>
    return <Grid container direction="column" spacing={2} alignItems="center">
        <Grid item>
            <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#e2f3e9', display: 'grid', placeItems: 'center' }}>
                <CheckCircleOutlineIcon style={{ fontSize: '40px', color: '#1e7a46' }} />
            </div>
        </Grid>
        <Grid item>
            <Typography variant="h6" data-testid="renewed-through" style={{ textAlign: 'center' }}>
                {end ? `You're renewed through ${end}` : "You're renewed"}
            </Typography>
        </Grid>
        <Grid item style={{ width: '100%', maxWidth: 460 }}>
            {row('Plan', planDisplay(plan).name)}
            {row('Billing', payerLine)}
            {(start || end) && row('Term', end ? `${start || 'Today'} – ${end}` : `From ${start || 'today'}, ongoing, billed monthly`)}
        </Grid>
        <Grid item>
            <Typography color="textSecondary">A confirmation email is on its way.</Typography>
        </Grid>
        <Grid item>
            <Button variant="contained" color="primary" onClick={onDone}>Back to my account</Button>
        </Grid>
    </Grid>
}

export default Confirmation
